// Service listing form options — kept as canonical arrays so that the
// enum values stored on the backend stay consistent with what the user
// picked in the UI. Labels are user-facing; values are what goes to the API.

export const SERVICE_MODE_OPTIONS = [
  { value: 'onsite', label: 'On-site at customer' },
  { value: 'at_provider', label: 'At our facility' },
  { value: 'remote', label: 'Remote / online' },
  { value: 'hybrid', label: 'Hybrid (onsite + remote)' },
];

export const TRAVEL_CAPABILITY_OPTIONS = [
  { value: '5_km', label: 'Up to 5 km' },
  { value: '50_km', label: 'Up to 50 km' },
  { value: '200_km', label: 'Up to 200 km' },
  { value: 'state', label: 'State-wide' },
  { value: 'all_india', label: 'All India' },
  { value: 'international', label: 'International' },
];

export const PRICING_MODEL_OPTIONS = [
  { value: 'hourly', label: 'Hourly' },
  { value: 'per_visit', label: 'Per visit' },
  { value: 'per_project', label: 'Per project' },
  { value: 'retainer', label: 'Retainer / AMC' },
  { value: 'on_request', label: 'On request' },
];

export const RESPONSE_TIME_OPTIONS = [
  { value: 'same_day', label: 'Same day' },
  { value: '24h', label: 'Within 24 hours' },
  { value: '48h', label: 'Within 48 hours' },
  { value: 'within_week', label: 'Within a week' },
];

export const EMERGENCY_SERVICE_OPTIONS = [
  { value: 'no', label: 'No' },
  { value: 'yes', label: 'Yes' },
  { value: '24x7', label: '24×7 available' },
];

export const VISIT_CHARGE_OPTIONS = [
  { value: 'free', label: 'Free visit' },
  { value: 'paid', label: 'Paid visit' },
  { value: 'included', label: 'Included in quote' },
];

// Label lookup helpers — used by cards & filter chips so we don't repeat
// find() logic in every consumer.
export const labelFor = (opts, value) => {
  const hit = opts.find(o => o.value === value);
  return hit ? hit.label : value;
};
